export const actions = {
    REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",
    SET_PAGE_NOTIFICATION: "SET_PAGE_NOTIFICATION",
    ADD_PAGE_NOTIFICATION: "ADD_PAGE_NOTIFICATION",
    REMOVE_PAGE_NOTIFICATION: "REMOVE_PAGE_NOTIFICATION",
    REMOVE_PAGE_NOTIFICATIONS: "REMOVE_PAGE_NOTIFICATIONS",
    SET_PERMANENT_PAGE_NOTIFICATION: "SET_PERMANENT_PAGE_NOTIFICATION",
    ADD_PERMANENT_PAGE_NOTIFICATION: "ADD_PERMANENT_PAGE_NOTIFICATION",
    REMOVE_PERMANENT_PAGE_NOTIFICATION: "REMOVE_PERMANENT_PAGE_NOTIFICATION",
    REMOVE_PERMANENT_PAGE_NOTIFICATIONS: "REMOVE_PERMANENT_PAGE_NOTIFICATIONS",
    SET_WEBSOCKET_NOTIFICATION_ERROR: "SET_WEBSOCKET_NOTIFICATION_ERROR",
};

export const initialState = {
    pageNotifications: [],
    permanentPageNotifications: [],
    hasWebsocketError: false,
};

const obtainNotificationKey = (response, position) =>
    /*
    let key = response?.code;

    if (response?.errors?.code) {
        key = `${response.code}-${response.errors.code}`;
    } else if (response?.data?.id) {
        key = `${response.code}-${response.data.id}`;
        // eslint-disable-next-line camelcase
    } else if (response?.id) {
        key = `${response.code}-${response.id}`;
        // eslint-disable-next-line camelcase
    } else if (response?.error_key) {
        // eslint-disable-next-line camelcase
        key = `${response.code}-${response.error_key}`;
    }
    */
    `${position}-${JSON.stringify(response)}`; // response is always non-circular object without references, safe for JSON.stringify() operation

const formatNotificationData = (response, position) => {
    // Copy first — mutating the action payload lets a caller that reuses the same error
    // object observe a silently rewritten `code`.
    const formatted = { ...response };
    if (formatted.error_key) {
        formatted.code = formatted.error_key;
    }
    return { ...formatted, identifier: obtainNotificationKey(formatted, position) };
};

export default (state = initialState, { type, response, identifier, initiator }) => {
    switch (type) {
        // PAGE NOTIFICATIONS
        case actions.SET_PAGE_NOTIFICATION: {
            return {
                ...state,
                pageNotifications: [formatNotificationData(response, "page")],
            };
        }
        case actions.ADD_PAGE_NOTIFICATION: {
            const pageNotifications = [...state.pageNotifications];
            pageNotifications.unshift(formatNotificationData(response, "page"));
            return {
                ...state,
                pageNotifications,
            };
        }
        case actions.REMOVE_PAGE_NOTIFICATION: {
            return {
                ...state,
                pageNotifications: [...state.pageNotifications].filter(
                    (item) => item.identifier !== identifier
                ),
            };
        }
        case actions.REMOVE_PAGE_NOTIFICATIONS: {
            if (initiator && initiator === "router") {
                return {
                    ...state,
                    pageNotifications: [...state.pageNotifications].filter(
                        (item) => item.skipNotificationClearOnRouteChange
                    ),
                };
            }
            return {
                ...state,
                pageNotifications: [],
            };
        }

        // PERMANENT PAGE NOTIFICATIONS

        case actions.SET_PERMANENT_PAGE_NOTIFICATION: {
            return {
                ...state,
                permanentPageNotifications: [formatNotificationData(response, "permanentPage")],
            };
        }
        case actions.ADD_PERMANENT_PAGE_NOTIFICATION: {
            const permanentPageNotifications = [...state.permanentPageNotifications];
            permanentPageNotifications.unshift(formatNotificationData(response, "permanentPage"));
            return {
                ...state,
                permanentPageNotifications,
            };
        }
        case actions.REMOVE_PERMANENT_PAGE_NOTIFICATION: {
            return {
                ...state,
                permanentPageNotifications: [...state.permanentPageNotifications].filter(
                    (item) => item.identifier !== identifier
                ),
            };
        }
        case actions.REMOVE_PERMANENT_PAGE_NOTIFICATIONS: {
            return {
                ...state,
                permanentPageNotifications: [],
            };
        }

        // GENERAL
        case actions.REMOVE_NOTIFICATION: {
            return {
                ...state,
                pageNotifications: [...state.pageNotifications].filter(
                    (item) => item.identifier !== identifier
                ),
                permanentPageNotifications: [...state.permanentPageNotifications].filter(
                    (item) => item.identifier !== identifier
                ),
            };
        }

        case actions.SET_WEBSOCKET_NOTIFICATION_ERROR: {
            if (state.hasWebsocketError === response) {
                return state;
            }
            return { ...state, hasWebsocketError: response };
        }
        default:
            return state;
    }
};
